import { withRedemptionToken } from '@utils/redemptionRoute';
import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router';

import { RedemptionLayout } from '../components/RedemptionLayout';

export const ErrorPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get('code') || 'network';
  const token = searchParams.get('token');
  const message =
    errorCode === 'invalid' || errorCode === 'expired'
      ? t('error_page.invalid_token')
      : errorCode === 'already_redeemed'
        ? t('error_page.already_redeemed')
        : errorCode === 'authentication'
          ? t('error_page.authentication')
          : t('error_page.network_error');

  return (
    <RedemptionLayout>
      <div className="redemption-result">
        <div className="redemption-status-icon">
          <CircleAlert size={27} aria-hidden="true" />
        </div>
        <h1>{t('error_page.title')}</h1>
        <p className="redemption-body">{message}</p>
        <div className="redemption-actions">
          {errorCode === 'network' && (
            <Link className="redemption-primary" to={withRedemptionToken('/redeem', token)}>
              {t('error_page.try_again')}
            </Link>
          )}
          <a className="redemption-text-link" href="mailto:support@remente.com">
            {t('error_page.contact_support')}
          </a>
        </div>
      </div>
    </RedemptionLayout>
  );
};
